/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type ReactNode, type ComponentType } from 'react';
import { ClientOnlyNavigationContainers } from './client-only-navigation-containers/index.tsx';
import type { NavigationContainersProps } from './types.tsx';

const ServerContainers: ComponentType<{ children: ReactNode }> = ({
	children,
}: {
	children: ReactNode;
}) => <>{children}</>;

export const NavigationContainers = ({
	children,
}: NavigationContainersProps): React.JSX.Element => {
	const Containers = !__SERVER__ ? ClientOnlyNavigationContainers : ServerContainers;

	return <Containers>{children}</Containers>;
};
